<template>
    <div :class="componentName === 'FilmForm' ? 'film_form_component' : ''" v-if="!isLoading && project !== null">

        <p class="back_link">
            <a href="/film_company">
                <svg width="14.000000" height="11.000000" viewBox="0 0 14 11" fill="none"
                     xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <path id="Vector 1 (Border)"
                          d="M2.65796 6.32568L5.72949 9.58704C6.03735 9.91406 6.03735 10.4279 5.72949 10.7548C5.42139 11.0818 4.93774 11.0818 4.62964 10.7548L0.230957 6.08386C-0.0769043 5.75696 -0.0769043 5.24304 0.230957 4.91614L4.62964 0.245239C4.93774 -0.0817871 5.42139 -0.0817871 5.72949 0.245239C6.03735 0.572144 6.03735 1.08594 5.72949 1.41296L2.65796 4.67432L13.2224 4.67432C13.658 4.67432 14 5.0376 14 5.5C14 5.9624 13.658 6.32568 13.2224 6.32568L2.65796 6.32568Z"
                          fill="#EC983F" fill-opacity="1.000000" fill-rule="evenodd"/>
                </svg>
                <span>Личный кабинет</span></a>
        </p>

        <div class="columns">
            <div class="column">
                <div class="header_title">
                    <template v-if="!this.project.id">
                        Создать фильм
                    </template>
                    <template v-else>
                        Редактировать фильм
                    </template>
                </div>
            </div>
            <div class="column is-narrow">
                <div>
                    <p v-if="!project.isPublished"><a @click="publishProjectHandler" class="button4">Опубликовать</a></p>
                    <p v-else>Фильм опубликован</p>
                </div>
            </div>
        </div>

        <form id="project_form">
            <div class="errors-block" v-if="errors.length">
                <b>Пожалуйста, заполните поля:</b>
                <ul>
                    <li v-for="(error,index) in errors" :key="index" v-html="error.text"></li>
                </ul>
            </div>

            <div class="gray_box">
                <p class="gray_box_title">Общая информация</p>
                <div class="columns">
                    <div class="column">
                        <BaseInput3
                                label="Название фильма"
                                v-model="project.name"
                                v-if="isFieldVisible('name')"
                                objectKey="name"
                                @onChange="saveData"
                                :isDataUpdated="isDataUpdating"
                                :isFormSubmitted="isSubmitted"
                        ></BaseInput3>

                        <div class="field" v-if="isFieldVisible('category')">
                            <label :class="this.isFieldRequired('category') ? 'req': ''">Формат</label>
                            <div class="select-field">
                                <select v-if="selectedCompetition?.formats" :disabled="isDataUpdating"
                                        @change="saveData" v-model="project.category">
                                    <option v-for="(format,index) in selectedCompetition.formats" :key="index"
                                            :value="format">{{ format }}
                                    </option>
                                </select>
                                <select v-else :disabled="isDataUpdating" @change="saveData"
                                        v-model="project.category">
                                    <option value="Полнометражный фильм">Полнометражный фильм</option>
                                    <option value="Короткометражный фильм">Короткометражный фильм</option>
                                    <option value="Сериал">Сериал</option>
                                </select>
                            </div>
                        </div>

												<div class="field">
                            <label>Жанры</label>
                            <Select
																		placeholder="Выберите жанры"
                                    v-model:value="project.zhanr"
                                    :options="[
                                      {value: 'Анимация'},
                                      {value: 'Биография'},
                                      {value: 'Боевик'},
                                      {value: 'Вестерн'},
                                      {value: 'Детектив'},
                                      {value: 'Документальное'},
                                      {value: 'Драма'},
                                      {value: 'Детское кино'},
                                      {value: 'Исторический фильм'},
                                      {value: 'Комедия'},
                                      {value: 'Мелодрама'},
                                      {value: 'Мистика'},
                                      {value: 'Музыкальный фильм'},
                                      {value: 'Нуар'},
                                      {value: 'Политический фильм'},
                                      {value: 'Приключенческий фильм'},
                                      {value: 'Сказка'},
                                      {value: 'Трагедия'},
                                      {value: 'Трагикомедия'},
                                      {value: 'Триллер'},
                                      {value: 'Фантастика'},
                                      {value: 'Фильм-катастрофа'},
                                      {value: 'Фэнтези'}
                                    ]"
                                    mode="tags"
																		style="width: 100%"
																		@change="saveData"
														></Select>
												</div>

                        <div class="columns">
                            <div class="column">
                                <BaseInput3
                                        label="Год выпуска"
                                        v-model="project.publishYear"
                                        v-if="isFieldVisible('publish_year')"
                                        objectKey="publish_year"
                                        @onChange="saveData"
                                        :isDataUpdated="isDataUpdating"
                                        :isFormSubmitted="isSubmitted"
                                ></BaseInput3>
														</div>
                            <div class="column">
                                <BaseInput3
                                        label="Хронометраж"
                                        description="Например, 90 минут"
                                        v-model="project.chronometr"
                                        v-if="isFieldVisible('chronometr')"
                                        objectKey="chronometr"
                                        @onChange="saveData"
                                        :isDataUpdated="isDataUpdating"
                                        :isFormSubmitted="isSubmitted"
                                ></BaseInput3>
														</div>
                        </div>

                        <div class="field" v-if="isFieldVisible('age_limit')">
                            <label :class="this.isFieldRequired('age_limit') ? 'req': ''">Возрастное ограничение</label>
                            <div class="select-field">
                                <select :disabled="isDataUpdating" @change="saveData"
                                        v-model="project.projectData.age_limit">
                                    <option value="0+">0+</option>
                                    <option value="6+">6+</option>
                                    <option value="12+">12+</option>
                                    <option value="16+">16+</option>
                                    <option value="18+">18+</option>
                                </select>
                            </div>
                        </div>


                        <BaseChoiseSelect
                                label="Статус фильма"
                                v-model="project.projectData.status"
                                :is-required="true"
                                :values="[
                                {
                                  'value': 'Реализован',
                                  'label': 'Реализован'
                                },
                                {
                                  'value': 'В производстве',
                                  'label': 'В производстве'
                                }
															]"
                                @onChange="saveData"
                        ></BaseChoiseSelect>


                        <div class="field" v-if="isFieldVisible('production')">
                            <label :class="this.isFieldRequired('production') ? 'req': ''">Производство (студия,
                                производитель и.т.д.)</label>
                            <textarea :disabled="isDataUpdating" @change="saveData" placeholder=""
                                      v-model="project.production"></textarea>
                        </div>

                        <div class="columns">
<!--                            <div class="column">-->
<!--                                <div class="field" v-if="isFieldVisible('motivation')">-->
<!--                                    <label :class="this.isFieldRequired('motivation') ? 'req': ''">Формат фильма для-->
<!--                                        показа</label>-->
<!--                                    <div class="select-field">-->
<!--                                        <select :disabled="isDataUpdating" @change="saveData" v-model="project.motivation">-->
<!--                                            <option value="prores">prores</option>-->
<!--                                            <option value="mp4">mp4</option>-->
<!--                                            <option value="DCP">DCP</option>-->
<!--                                        </select>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--														</div>-->
                            <div class="column">
                                <BaseInput3
                                        label="Номер прокатного удостоверения"
                                        description="№___ от __.______.20__"
                                        v-model="project.filmLanguage"
                                        v-if="isFieldVisible('filmLanguage')"
                                        objectKey="filmLanguage"
                                        @onChange="saveData"
                                        :isDataUpdated="isDataUpdating"
                                        :isFormSubmitted="isSubmitted"
                                ></BaseInput3>
														</div>
                        </div>
                    </div>
                    <div class="column">

                        <div class="poster_wrapper">
                            <ImageUpload
                                    label="Постер (Формат jpeg/png. Макс. 1,5 мегабайт)"
                                    :image-name="project.clearAfisha"
                                    :image-path="'/uploads/images/project/'"
                                    :is-data-updating="isDataUpdating"
                                    :entity-id="project.id"
                                    :aspect-ratio="366 / 546"
                                    description="Ссылка на скачивание постера фильма
                                * (ссылка должна быть действительна до даты окончания конкурса/акции)"
                                    @save-image="setPoster"
                            ></ImageUpload>
                        </div>

                        <BaseInput3
                                label="Ссылка на скачивание постера фильма"
                                description="ссылка должна быть действительна до даты окончания конкурса/акции. Вертикальный формат."
                                v-model="project.projectData.poster_link"
                                v-if="isFieldVisible('poster_link')"
                                objectKey="poster_link"
                                @onChange="saveData"
                                :isDataUpdated="isDataUpdating"
                                :isFormSubmitted="isSubmitted"
                        ></BaseInput3>

                        <BaseInput3
                                label="Ссылка на скачивание кадров из фильма"
                                v-model="project.tagline"
                                v-if="isFieldVisible('tagline')"
                                objectKey="tagline"
                                @onChange="saveData"
                                :isDataUpdated="isDataUpdating"
                                :isFormSubmitted="isSubmitted"
                        ></BaseInput3>

                        <BaseInput3
                                label="Ссылка на скачивание фотографий со съемок фильма"
                                v-model="project.projectData.foto_links"
                                v-if="isFieldVisible('foto_links')"
                                objectKey="foto_links"
                                @onChange="saveData"
                                :isDataUpdated="isDataUpdating"
                                :isFormSubmitted="isSubmitted"
                        ></BaseInput3>

<!--                        <BaseInput3-->
<!--                                label="Ссылка на трейлер"-->
<!--                                description="ссылка на ютуб в открытом доступе"-->
<!--                                v-model="project.projectData.treiler"-->
<!--                                v-if="isFieldVisible('treiler')"-->
<!--                                objectKey="treiler"-->
<!--                                @onChange="saveData"-->
<!--                                :isDataUpdated="isDataUpdating"-->
<!--                                :isFormSubmitted="isSubmitted"-->
<!--                        ></BaseInput3>-->

                        <BaseVideoLink
													label="Ссылка на трейлер"
                          description="ссылка на ютуб видео (в формате https://www.youtube.com/watch?v=iWkpGslUNiM)"
                          v-model:value="project.projectData.treiler"
                          v-model:type="project.projectData.treiler_type"
                          :isDataUpdated="isDataUpdating"
                          :isFormSubmitted="isSubmitted"
                          @onChange="saveData"
												></BaseVideoLink>

                        <BaseInput3
                                label="Ссылка для просмотра"
                                v-model="project.videoLink"
                                v-if="isFieldVisible('video_link')"
                                @onChange="saveData"
                                objectKey="videoLink"
                                :isDataUpdated="isDataUpdating"
                                :isFormSubmitted="isSubmitted"
                        ></BaseInput3>
												<p class="descr">Просмотровая версия для байеров и фестивальных отборщиков
                            Все ссылки должны быть действительны до даты окончания конкурса/акции</p>

                        <!--                        <div v-if="project.afisha">-->
                        <!--                            <img :src="'/uploads/images/' + project.afisha" id="image">-->
                        <!--                        </div>-->

                        <!--                        <vue-cropper-->
                        <!--                                ref="cropper"-->
                        <!--                                :src="imgSrc"-->
                        <!--                                alt="Source Image"-->
                        <!--                                :aspect-ratio="366 / 546"-->
                        <!--                                preview=".preview"-->
                        <!--                                v-if="imgSrc != ''"-->
                        <!--                        >-->
                        <!--                        </vue-cropper>-->
                        <!--                        <button class="button2" @click.prevent="cropImage" v-if="imgSrc != ''"-->
                        <!--                                style="margin-right: 40px;">-->
                        <!--                            Сохранить изображение-->
                        <!--                        </button>-->

                        <!--                        <div class="field" v-if="isFieldVisible('afisha')">-->
                        <!--                            <label :class="this.isFieldRequired('afisha') ? 'req': ''" for="project_afisha">Постер-->
                        <!--                                (Формат jpeg/png. Макс. 1,5 мегабайт)</label>-->
                        <!--                            <i class="fas fa-download"></i>-->
                        <!--                            <input :disabled="isDataUpdating" type="file" accept="image/*" id="project_afisha"-->
                        <!--                                   name="project[afisha]" @change="setImage">-->
                        <!--                            <div id="fileList"></div>-->
                        <!--                            <p style="font-size: 13px; margin-top: 10px;">Ссылка на скачивание постера фильма-->
                        <!--                                * (ссылка должна быть действительна до даты окончания конкурса/акции)</p>-->
                        <!--                        </div>-->

                    </div>
                </div>
            </div>

            <div class="gray_box">
                <p class="gray_box_title">География</p>
                <div class="columns">
                    <div class="column">
                        <BaseLocation
                                v-if="project !== null && countriesinput.length > 0"
                                :countriesinput="countriesinput"
                                countryKey="country"
                                cityKey="city"
                                regionKey="region"
                                labelCountry="Страна съемок"
                                labelCity="Город съемок"
                                labelRegion="Регион съемок"
                                :isDataUpdating="isDataUpdating"
                        ></BaseLocation>
                    </div>
                    <div class="column">
                        <BaseLocationOnlyMultipleCountry
                                labelCountry="Страна производства"
                                countryKey="production_country"
                                @onChange="production_country_change"
                                v-model="project.projectData.production_country"
                                :isDataUpdating="false"
                        >
                        </BaseLocationOnlyMultipleCountry>
                    </div>
                </div>
            </div>

            <div class="gray_box">
                <p class="gray_box_title">Съемочная группа</p>
                <div class="columns">
                    <div class="column">
                        <BaseInput3
                                label="Полное ФИО режиссера"
                                v-model="project.rezhiser"
                                v-if="isFieldVisible('rezhiser')"
                                objectKey="rezhiser"
                                @onChange="saveData"
                                :isDataUpdated="isDataUpdating"
                                :isFormSubmitted="isSubmitted"
                        ></BaseInput3>

                        <TinymceEditor
                                label="Биография режиссера"
                                v-model="project.projectData.regiserBiografy"
                                v-if="isFieldVisible('regiserBiografy')"
                                objectKey="regiserBiografy"
                                parentKey="projectData"
                                :isDataUpdating="isDataUpdating"
                        ></TinymceEditor>

                        <TinymceEditor
                                label="Фильмография режиссера"
                                v-model="project.logline"
                                v-if="isFieldVisible('logline')"
                                objectKey="logline"
                                :isDataUpdating="isDataUpdating"
                        ></TinymceEditor>

                    </div>
                    <div class="column">
                        <div class="field" v-if="isFieldVisible('produser')">
                            <label :class="this.isFieldRequired('produser') ? 'req': ''">Полное ФИО продюсера</label>
                            <textarea :disabled="isDataUpdating" @change="saveData" placeholder=""
                                      v-model="project.projectData.produser"></textarea>
                        </div>

                        <div class="field" v-if="isFieldVisible('prioritySocial')">
                            <label :class="this.isFieldRequired('prioritySocial') ? 'req': ''">Съемочная группа</label>
                            <textarea :disabled="isDataUpdating" @change="saveData" placeholder=""
                                      v-model="project.prioritySocial"></textarea>
                        </div>

                        <div class="field" v-if="isFieldVisible('inroles')">
                            <label :class="this.isFieldRequired('inroles') ? 'req': ''">Исполнители главных
                                ролей/герои</label>
                            <textarea :disabled="isDataUpdating" @change="saveData" placeholder=""
                                      v-model="project.projectData.inroles"></textarea>
                        </div>

                    </div>
                </div>
            </div>

            <div class="gray_box">
                <p class="gray_box_title">Описание фильма</p>
                <div class="columns">
                    <div class="column">
                        <TinymceEditor
                                label="Аннотация"
                                v-model="project.annotation"
                                v-if="isFieldVisible('annotation')"
                                objectKey="annotation"
                                description="Описание фильма для сайта"
                                :isDataUpdating="isDataUpdating"
                        ></TinymceEditor>

                        <div class="field" v-if="isFieldVisible('tsitata')">
                            <label :class="this.isFieldRequired('tsitata') ? 'req': ''">Цитата авторов фильма
                                (продюсера,
                                режиссера) - для пресс-клипинга</label>
                            <textarea :disabled="isDataUpdating" @change="saveData" placeholder=""
                                      v-model="project.projectData.tsitata"></textarea>
                        </div>

                    </div>
                    <div class="column">
                        <TinymceEditor
                                label="Краткая аннотация"
                                v-model="project.projectData.short_annotation"
                                v-if="isFieldVisible('short_annotation')"
                                objectKey="short_annotation"
                                parent-key="projectData"
                                description="Описание фильма в одном предложении"
                                :isDataUpdating="isDataUpdating"
                        ></TinymceEditor>

                        <div class="field" v-if="isFieldVisible('uniq')">
                            <label :class="this.isFieldRequired('uniq') ? 'req': ''">В чем уникальность фильма</label>
                            <textarea :disabled="isDataUpdating" @change="saveData" placeholder=""
                                      v-model="project.projectData.uniq"></textarea>
                        </div>
                        <div class="field" v-if="isFieldVisible('ychastie')">
                            <label :class="this.isFieldRequired('ychastie') ? 'req': ''">Участие в питчингах, конкурсах,
                                фестивалях</label>
                            <textarea :disabled="isDataUpdating" @change="saveData" placeholder=""
                                      v-model="project.projectData.ychastie"></textarea>
                        </div>
                    </div>
                </div>
            </div>

            <div class="gray_box">
                <p class="gray_box_title">Финансы</p>
                <div class="columns">
                    <div class="column">
                        <div class="field" v-if="isFieldVisible('finance_sources')">
                            <label :class="this.isFieldRequired('finance_sources') ? 'req': ''">Источники финансирования
                                фильма</label>
                            <textarea :disabled="isDataUpdating" @change="saveData" placeholder=""
                                      v-model="project.projectData.finance_sources"></textarea>
                        </div>
										</div>
                    <div class="column">
                        <BaseInput3
                                label="Бюджет фильма"
                                v-model="project.projectData.budget"
                                v-if="isFieldVisible('budget')"
                                objectKey="budget"
                                @onChange="saveData"
                                :isDataUpdated="isDataUpdating"
                                :isFormSubmitted="isSubmitted"
                        ></BaseInput3>
										</div>
                </div>
            </div>

            <div class="gray_box">
                <div class="columns">
                    <div class="column">
                        <div class="field" v-if="isFieldVisible('podderzhka')">
                            <label :class="this.isFieldRequired('podderzhka') ? 'req': ''">Укажите, если проект поддержан Министерством культуры, Фондом кино, ПФКИ, ФПГ, ФПРК, ИРИ, Росмолодежь и др.</label>
                            <textarea :disabled="isDataUpdating" @change="saveData" placeholder=""
                                      v-model="project.projectData.podderzhka"></textarea>
                        </div>
                    </div>
										<div class="column"></div>

                </div>
            </div>

            <div class="columns">
                <div class="column">
                    <div class="header_title">
                        <template v-if="this.project.id">
                            <a :href="'/project/delete_ajax/'+project.id" class="button4_white">Удалить</a>
                        </template>
                    </div>
                </div>
								<div class="column">
                    <div style="text-align: right">
                        <p v-if="!project.isPublished"><a @click="publishProjectHandler" class="button4">Опубликовать</a></p>
                        <p v-else>Фильм опубликован</p>
                    </div>
								</div>
            </div>
        </form>
    </div>
    <div v-else style="text-align: center">
        <div class="lds-default">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
</template>

<script>
import BaseInput from "../Base/BaseInput.vue";
import BaseInput2 from "../Base/BaseInput2.vue";
import BaseInput3 from "../Base/BaseInput3.vue";
import TinymceEditor from "../Base/TinymceEditor.vue";
import BaseLocation from "../Base/BaseLocation.vue";
import BaseLocationOnlyMultipleCountry from "../Base/BaseLocationOnlyMultipleCountry.vue";
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
import {faQuestion} from '@fortawesome/free-solid-svg-icons';
import {message, Select} from "ant-design-vue";
import Json from '@/services/json'


import {library} from '@fortawesome/fontawesome-svg-core';

library.add(faQuestion);
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';
import axios from "axios";
import ImageUpload from "@/components/Base/ImageUpload.vue";
import BaseChoiseSelect from "@/components/Base/BaseChoiseSelect.vue";
import BaseVideoLink from "@/components/Base/BaseVideoLink.vue";
import ImageRender from "@/components/Base/ImageRender.vue";
import ImageService from "@/services/ImageService";

export default {
  name: 'FilmForm',
  props: {
    isSubmitted: {},
    selectedCompetition: {}
  },
  async created() {
    this.isLoading = true;
    //await this.checkIsUserFillProfile();

    if (window.projectId.length > 0) {
      this.project.id = window.projectId;
    }

    await this.getData()

    //Если выбран активный конкурс, куда подается заявка.
    // if (window.competitionId?.length > 0) {
    //   this.selectedCompetitionId = window.competitionId;
    //   //this.loadCompetition(this.selectedCompetitionId);
    //   this.$emit('loadCompetition', this.selectedCompetitionId)
    //
    //   // if (window.new.length > 0) {
    //   //   this.getData(false, false);
    //   // } else {
    //   //   this.getData(true, true);
    //   // }
    //   this.getData(true, true);
    // } else {
    //   //this.loadCompetitions(1);
    //   this.$emit('loadCompetitions', 1)
    //
    //   //Если после добавления нового проекта.
    //   // if (window.new.length > 0) {
    //   //   this.getData(false, false);
    //   // } else {
    //   //   this.getData()
    //   // }
    //   this.getData()
    // }

    await this.loadCountries();

    this.isLoading = false;
  },
  data() {
    return {
      imgSrc: '',
      project: {
        name: '',
        clearAfisha: '',
        category: '',
        zhanr: [],
        afisha: '',
        publishYear: '',
        production: '',
        chronometr: '',
        region: '',
        rezhiser: '',
        prioritySocial: '',
        isPublished: false,
        annotation: '',
        videoSource: '',
        socialVideolink: '',
        tagline: '',
        // additionalInfo: '',
        presentationAbout: '',
        logline: '',
        filmLanguage: '',
        treiler: '',
        motivation: '',
        videoLink: '',
        user: '',
        projectData: {
          vid: '',
          age_limit: '',
          inroles: '',
          podderzhka: '',
          regiserBiografy: '',
          short_annotation: '',
          finance_sources: '',
          tsitata: '',
          uniq: '',
          poster_link: '',
          produser: '',
          ychastie: '',
          foto_links: '',
          production_country: [],
          treiler_type: '',
          status: ''
        }
      },
      isLoading: false,
      validationRules: [
        {
          fieldName: 'name',
          isRequired: true,
          errorText: 'Поле "Название фильма" обязательно для заполнения'
        },
        // {
        //   fieldName: 'vid',
        //   isRequired: true,
        //   parentEntity: 'projectData',
        //   errorText: 'Поле "Вид" обязательно для заполнения'
        // },
        {
          fieldName: 'category',
          isRequired: true,
          errorText: 'Поле "Формат" обязательно для заполнения'
        },
        {
          fieldName: 'zhanr',
          isRequired: true,
          errorText: 'Поле "Жанр" обязательно для заполнения'
        },
        {
          fieldName: 'publish_year',
          isRequired: true,
          errorText: 'Поле "Год выпуска" обязательно для заполнения'
        },
        {
          fieldName: 'production',
          isRequired: true,
          errorText: 'Поле "Производство" обязательно для заполнения'
        },
        {
          fieldName: 'chronometr',
          isRequired: true,
          errorText: 'Поле "Хронометраж" обязательно для заполнения'
        },
        {
          fieldName: 'age_limit',
          parentEntity: 'projectData',
          isRequired: true,
          errorText: 'Поле "Возрастное ограничение фильма" обязательно для заполнения'
        },
        {
          fieldName: 'status',
          parentEntity: 'projectData',
          isRequired: true,
          errorText: 'Поле "Статус фильма" обязательно для заполнения'
        },
        {
          fieldName: 'country',
          isRequired: true,
          errorText: 'Поле "Страна съемок" обязательно для заполнения'
        },
        {
          fieldName: 'city',
          isRequired: true,
          errorText: 'Поле "Город съемок" обязательно для заполнения'
        },
        {
          fieldName: 'region',
          isRequired: true,
          errorText: 'Поле "Регион съемок" обязательно для заполнения'
        },
        {
          fieldName: 'finance_sources',
          isRequired: true,
          parentEntity: 'projectData',
          errorText: 'Поле "Источники финансирования фильма" обязательно для заполнения'
        },
        {
          fieldName: 'rezhiser',
          isRequired: true,
          errorText: 'Поле "Полное ФИО режиссера" обязательно для заполнения'
        },
        {
          fieldName: 'produser',
          isRequired: true,
          errorText: 'Поле "Полное ФИО продюсера" обязательно для заполнения'
        },
        {
          fieldName: 'prioritySocial',
          isRequired: true,
          errorText: 'Поле "Съемочная группа" обязательно для заполнения'
        },
        {
          fieldName: 'inroles',
          parentEntity: 'projectData',
          isRequired: true,
          errorText: 'Поле "Исполнители главных ролей/герои" обязательно для заполнения'
        },
        {
          fieldName: 'annotation',
          isRequired: true,
          errorText: 'Поле "Аннотация" обязательно для заполнения'
        },
        {
          fieldName: 'short_annotation',
          isRequired: true,
          parentEntity: 'projectData',
          errorText: 'Поле "Краткая аннотация" обязательно для заполнения'
        },
        {
          fieldName: 'afisha',
          isRequired: true,
          errorText: 'Поле "Постер" обязательно для заполнения'
        },
        {
          fieldName: 'ychastie',
          isRequired: true,
          parentEntity: 'projectData',
          errorText: 'Поле "Участие в питчингах, конкурсах, фестивалях" обязательно для заполнения'
        },
        {
          fieldName: 'poster_link',
          isRequired: true,
          parentEntity: 'projectData',
          errorText: 'Поле "Ссылка на скачивание постера фильма" обязательно для заполнения'
        },
        // {
        //   fieldName: 'tagline',
        //   isRequired: true,
        //   errorText: 'Поле "Ссылка на скачивание кадров из фильма" обязательно для заполнения'
        // },
        // {
        //   fieldName: 'additionalInfo',
        //   isRequired: true,
        //   errorText: 'Поле "Полное ФИО режиссера + город (место\n' +
        //     'жительства)" обязательно для заполнения'
        // },
        // {
        //   fieldName: 'regiserBiografy',
        //   isRequired: true,
        //   parentEntity: 'projectData',
        //   errorText: 'Поле "Биография режиссера" обязательно для заполнения'
        // },
        // {
        //   fieldName: 'logline',
        //   isRequired: true,
        //   errorText: 'Поле "Фильмография режиссера" обязательно для заполнения'
        // },
        // {
        //   fieldName: 'filmLanguage',
        //   isRequired: true,
        //   errorText: 'Поле "Номер прокатного удостоверения" обязательно для заполнения'
        // },
        // {
        //   fieldName: 'treiler',
        //   isRequired: true,
        //   parentEntity: 'projectData',
        //   errorText: 'Поле "Ссылка на трейлер" обязательно для заполнения'
        // },
        {
          fieldName: 'videoLink',
          isRequired: true,
          errorText: 'Поле "Ссылка для просмотра" обязательно для заполнения'
        },
        {
          fieldName: 'podderzhka',
          isRequired: true,
          parentEntity: 'projectData',
          errorText: 'Поле "Укажите, если проект поддержан Министерством культуры, Фондом кино, ПФКИ, ФПГ, ФПРК, ИРИ, Росмолодежь и др." обязательно для заполнения'
        },

      ],
      countriesinput: [],
      isDataUpdating: false,
      tabNum: 1,
      errors: [],
      isUserFillProfile: false,
      isFormSubmitted: false,
      componentName: this.$options.name
    }
  },
  components: {
    BaseVideoLink,
    BaseChoiseSelect,
    ImageUpload,
    BaseInput,
    BaseInput2,
    BaseInput3,
    TinymceEditor,
    BaseLocation,
    VueCropper,
    FontAwesomeIcon,
    BaseLocationOnlyMultipleCountry,
    Select,
    ImageRender
  },
  // computed: {},
  methods: {
    setProjectFromResponse(projects_response) {
      projects_response.data = Json.replaceKeys(projects_response.data);
      projects_response.data.projectData = Json.handle_json_field(projects_response.data.projectData, this.project.projectData);

      this.project = projects_response.data;
    },
    async getData(checkErrors = true, showModal = false) {
      this.isDataUpdating = true;
      if ((this.project?.id && typeof this.project?.id === 'number') || (this.project?.id && typeof this.project?.id === 'string') && this.project?.id?.length > 0) {
        const projects_response = await axios.get('/api/projects/' + this.project.id + '.json');
        //this.project = projects_response.data;
        this.setProjectFromResponse(projects_response);
      }
      this.isDataUpdating = false;
    },
    handleEntityResponse(response) {
      if (response.headers['content-type'] === 'text/html; charset=UTF-8') {
        alert('Время соединения истекло. Войдите повторно в свой аккаунт.');
        window.location.reload();
      }
      this.setProjectFromResponse(response);
    },
    async createNewProject() {
      this.isDataUpdating = true;
      if (window.userid.length > 0 && window.isCompanyRole.length > 0) {

        this.project.user = "/api/users/" + window.userid;
        this.project.type = "film";

        if (this.project?.publishYear?.length === 0) {
          delete this.project.publishYear;
        }

        const response = await axios.post('/api/projects', this.project);
        await this.handleEntityResponse(response);

        history.pushState(null, null, window.location.href + "/" + this.project.id);

      } else {
        message.error('Ошибка сохранения')
      }
      this.isDataUpdating = false;
    },
    async patchProject() {
      this.isDataUpdating = true;

      if (this.project.isPublished) {
        await this.publishProject();
      }

      const project_object = structuredClone(this.project);

      delete project_object.user;
      delete project_object.afisha;

      if (project_object.publishYear?.length === 0) {
        delete project_object.publishYear;
      } else {
        project_object.publishYear = parseInt(this.project.publishYear)
      }

      const response = await axios.patch('/api/projects/' + this.project.id, project_object, {
        headers: {
          'Content-Type': "application/merge-patch+json"
        }
      }).catch((event) => {
        alert(event.response.data['hydra:description']);
      })
      this.handleEntityResponse(response);
      if (this.isFormSubmitted) {
        this.checkErrors();
      }

      this.isDataUpdating = false;
    },
    saveData: async function () {
      this.$emit('saveBegin');
      if (!this.project.id) {
        await this.createNewProject();
      } else {
        await this.patchProject();
      }

      this.$emit('saveEnd');
    },
    changeCurrentTab(num) {
      this.tabNum = num;
      document.getElementById('tabContent').scrollIntoView({behavior: 'smooth'});
    },
    isRequired(value) {
      return !(value && value.trim());
    },
    validateField(field) {
      const self = this;
      if (field.parentEntity !== undefined) {
        if (self.project) {
          if (field.isRequired && (self.project[field.parentEntity] === null || self.project[field.parentEntity][field.fieldName] === undefined || (self.project[field.parentEntity][field.fieldName] === null || self.project[field.parentEntity][field.fieldName].length === 0 || self.project[field.parentEntity][field.fieldName] === 0 || self.project[field.parentEntity][field.fieldName] === false))) {
            if (!self.errors.find(x => x.text === field.errorText)) {
              self.errors.push({
                text: field.errorText,
                order: field.order ? field.order : '1'
              });
            }
          }
        }
      } else {

        if (self.project) {
          if (field.isRequired && (self.project[field.fieldName] === null || self.project[field.fieldName]?.length === 0 || self.project[field.fieldName] === 0)) {
            if (!self.errors.find(x => x.text === field.errorText)) {
              self.errors.push({
                text: field.errorText,
                order: field.order ? field.order : '1'
              });
            }
          }
        }
      }
    },
    isFieldVisible(fieldName) {
      let res = true;
      if (this.selectedCompetition?.projectRules) {
        this.selectedCompetition?.projectRules.forEach(function (field) {
          if ((field.fieldName === fieldName || field?.altFieldName === fieldName) && !field.isRequired && !field.isNeeded) {
            res = false;
          }
        });
      }
      return res;
    },
    isFieldRequired(fieldName) {
      let res = false;
      this.validationRules.forEach(function (field) {
        if (
          (field.fieldName === fieldName || field?.altFieldName === fieldName)
          && field.isRequired) {
          res = true;
        }
      });
      if (this.selectedCompetition?.projectRules) {
        this.selectedCompetition?.projectRules.forEach(function (field) {
          if (
            (field.fieldName === fieldName || field?.altFieldName === fieldName)
            && field.isRequired) {
            res = true;
          }
        });
      }
      return res;
    },
    setImage(e) {
      const file = e.target.files[0];
      if (!file.type.includes("image/")) {
        alert("Загрузить можно только изображение");
        return;
      }
      if (file.size > 1572864) {
        alert("Максимальный размер изображения 1,5 мегабайта. Обработайте изображение в графических редакторах, чтобы уменьшить его размер.");
        return;
      }
      this.origfilename = file.name;
      const self = this;
      if (typeof FileReader === "function") {
        const reader = new FileReader();
        reader.onload = event => {
          self.imgSrc = event.target.result;
          // rebuild cropperjs with the updated source
          if (self.$refs.cropper) {
            self.$refs.cropper.replace(event.target.result);
          }
        };
        reader.readAsDataURL(file);
      } else {
        alert("Sorry, FileReader API not supported");
      }
    },
    async cropImage() {
      const self = this;

      this.$emit('saveBegin');
      if (!this.project.id) {
        await this.createNewProject();
      }
      this.$refs.cropper.getCroppedCanvas('getCroppedCanvas').toBlob(function (blob) {
        let formData = new FormData();
        formData.append('file', blob);
        formData.append('original-name', self.origfilename);
        formData.append('current-name', self.project.afisha);
        formData.append('entity-id', self.project.id);

        axios(
          {
            method: 'post',
            url: '/project/getProjectAvatar',
            data: formData
          }
        )
          .then(() => {
            self.imgSrc = '';
            self.getData();

          });
      })
      this.$emit('saveEnd');
    },
    async setPoster(formData) {
      this.$emit('saveBegin');
      if (!this.project.id) {
        await this.createNewProject();
      }

      await axios(
        {
          method: 'post',
          url: '/project/getProjectAvatar',
          data: formData
        }
      );
      this.getData();
      this.$emit('saveEnd');
    },
    checkErrors(withScroll = true, showModal = false) {
      const self = this;
      this.isLoading = true;
      self.errors = [];

      this.validationRules.forEach(function (field) {
        self.validateField(field)
      });
      if (this.selectedCompetition?.projectRules) {
        this.selectedCompetition?.projectRules.forEach(function (field) {
          self.validateField(field)
        });
        this.errors.sort((a, b) => a.order > b.order ? 1 : -1);
      }

      // if (!self.isUserFillProfile) {
      //   self.errors.push({
      //     text: 'Заполните информацию в своем Профиле <a href="https://script.moviestart.ru/profile?check=true">https://script.moviestart.ru/profile</a>',
      //     order: '1'
      //   });
      // }
      if (showModal) {
        self.$parent.showModal();
      }
      self.isLoading = false;
      self.$parent.isLoading = false;
      // if (withScroll && self.errors.length > 0) {
      //   if (document.getElementById("project_form")) {
      //     document.getElementById("project_form").scrollIntoView();
      //   }
      // }
    },
    checkIsUserFillProfile() {
      return new Promise((resolve, reject) => {
        const self = this;
        axios.get('/isUserFillProfile', {
          headers: {
            'Accept': 'application/json',
          }
        })
          .then(response => {
            self.isUserFillProfile = response.data;
            resolve(response.data)
          })
          .catch(error => {
            console.log(error);
            reject(error)
          });
      });
    },
    async loadCountries() {
      const response = await axios.get('/get_all_countries', {
        headers: {
          'Accept': 'application/json',
        }
      })
      this.countriesinput = response.data;
    },
    loadCities() {
      const self = this;
      const current_country = self.countriesinput.filter(function (el) {
        return el["ru_name"] === self.project.country;
      })
      if (current_country[0] && current_country[0].number) {
        axios.get('/get_world_cities/' + current_country[0].number, {
          headers: {
            'Accept': 'application/json',
          }
        }).then((response) => {
          self.citiestoinput = response.data;
        }).catch(error => {
          console.log(error);
        });
      }
    },
    production_country_change(val) {
      this.project.projectData.production_country = val;
      this.saveData();
    },
    async publishProjectHandler() {
      await this.publishProject();
      this.saveData();
		},
    async publishProject() {
      await this.checkErrors();
      this.isFormSubmitted = true;
      if (this.errors.length === 0) {
        this.project.isPublished = true;
      } else {
        this.project.isPublished = false;
      }
    },
    getProjectAvatar(avatar) {
      return ImageService.getProjectImagePath(avatar);
    }
  },
  computed: {},
  watch: {
    selectedCompetition(val) {
      this.checkErrors();
    },
    errors(val) {
      this.$emit('onErrorsChange', this.errors)
    }
  }
}
</script>

<style scoped>


.poster_wrapper .upload_image_field {
    margin-left: 0;
}

.field_description {
    font-size: 13px;
}

.modal {
    display: block;
    width: 80%;
    max-width: 950px;
    padding: 30px;
    box-sizing: border-box;
    background-color: #fff;
    font-size: 20px;
    text-align: center;
    margin: 30px auto 30px;
    position: relative;
}

.category_select_active {
    font-weight: bold;
}

.close_button {
    position: absolute;
    right: 15px;
    top: 10px;
    font-size: 20px;
    cursor: pointer;
}

.vue-universal-modal {
    z-index: 111;
}

.errors-block {
    color: red;
    border: 1px solid #999;
    border-radius: 10px;
    padding: 25px;
    margin-bottom: 30px;
}

.lds-default {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
    transform: scale(0.5);
    text-align: center;
}

.lds-default div {
    position: absolute;
    width: 6px;
    height: 6px;
    background: #000;
    border-radius: 50%;
    animation: lds-default 1.2s linear infinite;
}

.lds-default div:nth-child(1) {
    animation-delay: 0s;
    top: 37px;
    left: 66px;
}

.lds-default div:nth-child(2) {
    animation-delay: -0.1s;
    top: 22px;
    left: 62px;
}

.lds-default div:nth-child(3) {
    animation-delay: -0.2s;
    top: 11px;
    left: 52px;
}

.lds-default div:nth-child(4) {
    animation-delay: -0.3s;
    top: 7px;
    left: 37px;
}

.lds-default div:nth-child(5) {
    animation-delay: -0.4s;
    top: 11px;
    left: 22px;
}

.lds-default div:nth-child(6) {
    animation-delay: -0.5s;
    top: 22px;
    left: 11px;
}

.lds-default div:nth-child(7) {
    animation-delay: -0.6s;
    top: 37px;
    left: 7px;
}

.lds-default div:nth-child(8) {
    animation-delay: -0.7s;
    top: 52px;
    left: 11px;
}

.lds-default div:nth-child(9) {
    animation-delay: -0.8s;
    top: 62px;
    left: 22px;
}

.lds-default div:nth-child(10) {
    animation-delay: -0.9s;
    top: 66px;
    left: 37px;
}

.lds-default div:nth-child(11) {
    animation-delay: -1s;
    top: 62px;
    left: 52px;
}

.lds-default div:nth-child(12) {
    animation-delay: -1.1s;
    top: 52px;
    left: 62px;
}

.competition_wrapper {
    position: relative;
    max-width: 355px;
}

.modal .columns.is-multiline {
    justify-content: center;
}

.modal .columns.is-multiline .col1 {
    margin-right: 50px;
    margin-bottom: 70px;
}

.competiton_order_button_div {
    display: none;
}

.competition-info {
    background: #FEF4E5;
    padding: 20px;
}

.competition-image-wrapper {
    position: relative;
    display: flex;
    border-bottom: 5px solid #F69F22;
}

.choise_category h1 {
    font-size: 21px;
}

.vue-universal-modal {
    z-index: 111;
}

.competition-title__wrapper {
    line-height: 1;
}

.competition-title {
    font-size: 16px;
}

.category_select {
    font-size: 18px;
}

.content_block .tabs ul {
    align-items: inherit;
}

.content_block .tabs ul li {
    display: flex;
}

.category_select:hover {
    color: #F69F22;
    cursor: pointer;
}

.competition_wrapper_inner:hover .competiton_order_button_div {
    display: block;
}

.help_text {
    margin-bottom: 30px;
    margin-top: 30px;
    font-style: italic;
    color: #8F9194;
    cursor: pointer;
}

.help_text svg {
    margin-right: 10px;
}

.modal_question {
    text-align: left;
    font-size: 16px;
}
.film_form_component .back_link {
    padding-left: 0;
}
.poster_wrapper:deep .upload_image_field {
    margin-left: 0;
}
.poster_wrapper:deep .image__wrapper img {
		max-width: 250px;
}
.field {
    margin-top: 20px;
    margin-bottom: 20px;
}
.field:deep .ant-select-selector {
		min-height: 50px;
		background: rgb(254, 251, 249);
}
.field:deep input[type=text] {
		max-width: none;
}
.descr {
    color: rgba(34, 34, 34, 0.50);
    font-size: 14px;
}
@keyframes lds-default {
    0%, 20%, 80%, 100% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.5);
    }
}
</style>
